import { logger } from '../../../datadog';
import { normalizeError } from '../../../utils';
import { AudioCaptureFailedError, isZoomExecutedFailure, toZoomExecutedFailureError } from './error';

/**
 * Handles a Zoom operation that returns ExecutedResult and handles failures
 * @param operation - Description of the operation for error messages
 * @param zoomOperation - The async Zoom operation to execute
 */
export function handleError(operation: string, error: unknown, errorContext: object = {}): void {
  if (isZoomExecutedFailure(error)) {
    const zoomError = toZoomExecutedFailureError(error);
    const { type, errorCode, reason } = zoomError;
    const subCode = zoomError instanceof AudioCaptureFailedError ? zoomError.subCode : undefined;

    logger.error(`Zoom ${operation} failed`, { type, errorCode, reason, subCode }, zoomError);
  } else {
    logger.error(`${operation} failed`, errorContext, normalizeError(error));
  }
}
